module.exports = {"450481100":"岑城镇","450481102":"马路镇","450481103":"南渡镇","450481105":"水汶镇","450481106":"大隆镇","450481107":"梨木镇","450481108":"大业镇","450481109":"筋竹镇","450481110":"诚谏镇","450481111":"归义镇","450481112":"糯垌镇","450481113":"安平镇","450481114":"三堡镇","450481115":"波塘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450481.json
// module id = 2243
// module chunks = 0